import React from 'react';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import InputField from 'components/coaches-builder/InputField';
import { InputType } from 'components/coaches-builder/InputField/InputField';
import ProfileItem from 'components/coaches-builder/ProfileItem';
import classNames from 'styles/utils/classNames';

interface ExternalBookingContentProps {
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  visible: boolean;
  priceInputField: React.ReactNode | null;
}

const ExternalBookingContent: React.FC<ExternalBookingContentProps> = ({
  register,
  errors,
  visible,
  priceInputField,
}) => {
  return (
    <div className={classNames('flex flex-col', visible ? 'flex' : 'hidden')}>
      <div className="typography-product-subheading relative mb-[3.75rem] mt-9 w-full shrink-0 text-center text-color-text-lightmode-icon dark:text-color-text-darkmode-icon">
        <p>Players will be redirected to your external link to book 1-1 lessons.</p>
        <p>You can still create group clinics and share them on the Bounce marketplace.</p>
      </div>

      {priceInputField && (
        <ProfileItem
          customClass="!mt-0 max-md:mx-0"
          label="Private lesson cost"
          description="Even if you don't offer private lessons, this will help players understand the general cost of your services."
          hasBottomBorder={true}
          invert
          component={priceInputField}
        />
      )}

      <ProfileItem
        customClass="max-md:mx-0"
        label="External link"
        description="We will send players to this link if they want to book a lesson with you."
        hasBottomBorder={false}
        invert
        component={
          <InputField
            inputProps={{
              type: 'url',
              placeholder: 'https://',
            }}
            fieldLabel=""
            errors={errors}
            placeholder="https://"
            name="externalBookingUrl"
            register={register}
            inputType={InputType.Regular}
            errorBorder={true}
            invert
          />
        }
      />
    </div>
  );
};

export default ExternalBookingContent;
